/**
 * @author      Shivani Mehra
 * @date        Aug, 2024
 * @copyright   www.ibirdsservices.com
 */

import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify"; // npm i react-toastify --force
import "react-toastify/dist/ReactToastify.css";
import moment from "moment-timezone";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import { Link } from "react-router-dom";

const CampaignView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSpinner, setIsSpinner] = useState(false);
  const [campaignData, setCampaignData] = useState(
    location.state ? location.state : {},
  );
  const [body, setBody] = useState([]);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (campaignData?.campaign_id) {
      getMHRecords(campaignData?.campaign_id);
    }
  }, [campaignData]);

  const getMHRecords = async (id) => {
    const result = await WhatsAppAPI.getMsgHistoryDownload(id);
    if (result.success) {
      setIsSpinner(true);
      const limitedData = result.records.map((item) => ({
        ...item,
        message:
          item.message?.length > 100
            ? `${item.message.substring(0, 100)}...`
            : item.message,
      }));
      setHistory(limitedData);
      setBody(result.records);
    } else {
      setIsSpinner(true);
      setBody([]);
    }
  };

  // const labels = { beforeSelect: " " };
  const header = [
    { title: "Name", prop: "name", isFilterable: true },
    { title: "Phone", prop: "number", isFilterable: true },
    { title: "Delivery Status", prop: "delivery_status", isFilterable: true },
  ];

  const handleDownload = () => {
    if (body.length > 0) {
      downloadCSV(body);
      toast.success("File download successfully.");
    } else {
      toast.error("No data available to download");
    }
  };
  const downloadCSV = (data) => {
    const csv = convertToCSV(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "campaign_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const convertToCSV = (data) => {
    const header = ["Name", "Phone", "Status", "Error Message", "Message"];
    const rows = data.map((item) => [
      item.name,
      item.number,
      item.delivery_status,
      item.err_message,
      item.message,
    ]);
    return [
      header.join(","), // header row
      ...rows.map((row) => row.join(",")), // data rows
    ].join("\n");
  };

  const handleBack = () => {
    navigate("/campaign");
  };

  return (
    <>
      <div className="app-view-page">
        <div className="lead-header">
          <div>
            <p className="lead-label">Campaign</p>
            <h3 className="lead-title">{campaignData?.campaign_name}</h3>
          </div>
          <div className="lead-actions">
            <Button className="btn-sm btn-back" onClick={handleBack}>
              Back
            </Button>
          </div>
        </div>

        <div className="lead-card mt-3">
          <Row className="g-0 view-form">
            <Col lg={12} sm={12} xs={12}>
              <Row className="py-2 ibs-edit-form">
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Campaign Name</label>
                <span>{campaignData?.campaign_name || <>&nbsp;</>}</span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Schedule Date & Time</label>
                <span>
                  {moment(new Date(campaignData?.start_date)).format(
                    "DD-MM-YYYY h:mm:ss A",
                  ) || <>&nbsp;</>}
                </span>
              </Col>

              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label> Template Name</label>
                <span>
                  {campaignData?.template_name.replace(/_/g, " ") || (
                    <>&nbsp;</>
                  )}
                </span>
              </Col>
              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Group Name(s)</label>
                <span>{campaignData?.group_name || <>&nbsp;</>}</span>
              </Col>

              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Status</label>
                <span>{campaignData?.campaign_status || <>&nbsp;</>}</span>
              </Col>

              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Type</label>
                <span>{campaignData?.campaign_type || <>&nbsp;</>}</span>
              </Col>

              <Col lg={6} sm={6} xs={6} className="mb-2">
                <label>Lead Name(s)</label>
                <span>
                  {campaignData?.lead_ids &&
                  campaignData.lead_ids.length > 0 ? (
                    campaignData.lead_ids.map((lead, index) => (
                      <span
                        key={index}
                        style={{ display: "inline-block", marginRight: "8px" }}
                      >
                        <Link
                          to={`/leads/${lead.member_id}`}
                          style={{ textDecoration: "none", color: "blue" }}
                        >
                          {lead.name} ({lead.whatsapp_number})
                        </Link>
                        {index < campaignData.lead_ids.length - 1 && ", "}
                      </span>
                    ))
                  ) : (
                    <>&nbsp;</>
                  )}
                </span>
              </Col>

              <Col lg={6} sm={6} xs={6} className="mb-4">
                <label>Description</label>
                <span>{campaignData?.file_description || <>&nbsp;</>}</span>
              </Col>
            </Row>
          </Col>
        </Row>
        </div>

      {history?.length > 0 && (
        <div className="lead-card mt-3 py-2 px-3">
          <span className="fw-semibold text-uppercase small text-muted">
            Message history
          </span>
        </div>
      )}

      {isSpinner ? (
        history?.length > 0 && (
          <>
            <div className="lead-card mt-3 mb-5">
              <Row className="g-0">
                <Col lg={12} sm={12} xs={12} className="mb-3">
                  <Row className="g-0">
                    <Col lg={12} sm={12} xs={12}>
                      <DatatableWrapper
                        body={history}
                        headers={header}
                        paginationOptionsProps={{
                          initialState: {
                            rowsPerPage: 10,
                            options: [5, 10, 15, 20],
                          },
                        }}
                      >
                        <Row className="mb-2 d-flex justify-content-start">
                          <Col
                            lg={3}
                            sm={6}
                            xs={6}
                            className="d-flex flex-col justify-content-start align-items-start"
                          >
                            <Filter />
                          </Col>
                          <Col
                            lg={5}
                            sm={6}
                            xs={6}
                            className="d-flex flex-col justify-content-start align-items-start"
                          ></Col>
                          <Col
                            lg={4}
                            sm={6}
                            xs={6}
                            className="d-flex flex-col justify-content-end align-items-end"
                          >
                            <Button
                              className="btn btn-sm"
                              variant="outline-secondary"
                              onClick={handleDownload}
                            >
                              Download
                            </Button>
                          </Col>
                        </Row>
                        <Table
                          striped
                          className="related-list-table"
                          responsive="sm"
                        >
                          <TableHeader />
                          <TableBody />
                        </Table>

                        <Row className="mb-2">
                          <Col lg={6} sm={12} xs={12}>
                            <Pagination />
                          </Col>
                          <Col lg={6} sm={12} xs={12} className="text-end">
                            <span className="mx-2">
                              <b>Total Records:</b>{" "}
                              {body[0]?.total_records
                                ? body[0]?.total_records
                                : 0}
                            </span>
                            <span className="mx-2">
                              <b>Success:</b>{" "}
                              {body[0]?.success_count
                                ? body[0]?.success_count
                                : 0}
                            </span>
                            <span className="mx-2">
                              <b>Failled:</b>{" "}
                              {body[0]?.failed_count
                                ? body[0]?.failed_count
                                : 0}
                            </span>
                          </Col>
                        </Row>
                      </DatatableWrapper>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </>
        )
      ) : (
        <div className="sk-cube-grid">
          <div className="sk-cube sk-cube1"></div>
          <div className="sk-cube sk-cube2"></div>
          <div className="sk-cube sk-cube3"></div>
          <div className="sk-cube sk-cube4"></div>
          <div className="sk-cube sk-cube5"></div>
          <div className="sk-cube sk-cube6"></div>
          <div className="sk-cube sk-cube7"></div>
          <div className="sk-cube sk-cube8"></div>
          <div className="sk-cube sk-cube9"></div>
        </div>
      )}
      </div>

      <ToastContainer />
    </>
  );
};

export default CampaignView;
